import { ROUTE_PATH } from "@/common/constants/routing";
import { VehicleDamageDtoAny } from "@/common/mapping/mappers/vehicleDamage";
import {
  AppPermission,
  VehicleDamageDataDto,
  VehicleDamageDto,
  VehicleDamageFullReferenceDto,
  VehicleDamageReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import VehicleDamageInline, { VehicleDamageInlineProps } from "./VehicleDamageInline";

interface Props extends BaseEntityLinkInheritableProps {
  vehicleId: string | null | undefined;
  entity: Nil<VehicleDamageDtoAny>;
  entityId?: string | null;
  inlineProps?: Partial<VehicleDamageInlineProps>;
}

export default function VehicleDamageLink({
  vehicleId,
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  const full = entity as Nil<VehicleDamageDto>;
  const ref = entity as Nil<VehicleDamageReferenceDto | VehicleDamageFullReferenceDto>;
  const data = entity as Nil<VehicleDamageDataDto>;

  const vehicleIdComputed =
    full?.vehicle?.id || ref?.vehicleId || data?.vehicleId || vehicleId || undefined;
  const entityIdComputed = entity?.id || entityId || undefined;

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleDamageRead]}
      to={
        vehicleIdComputed
          ? ROUTE_PATH.VEHICLE_DAMAGE_VIEW({
              vehicleId: vehicleIdComputed,
              vehicleDamageId: entityIdComputed,
            })
          : ROUTE_PATH.VEHICLE_DAMAGE_VIEW_ALT({
              vehicleDamageId: entityIdComputed,
            })
      }
      content={<VehicleDamageInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
